
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class SubscriptionGrid extends Serenity.EntityGrid<SubscriptionRow, any> {
        protected getColumnsKey() { return SubscriptionColumns.columnsKey; }
        protected getDialogType() { return SubscriptionDialog; }
        protected getIdProperty() { return SubscriptionRow.idProperty; }
        protected getInsertPermission() { return SubscriptionRow.insertPermission; }
        protected getLocalTextPrefix() { return SubscriptionRow.localTextPrefix; }
        protected getService() { return SubscriptionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());

            // *** Enable Full size grid resize ***
            Common.GridHelper.EnableFullSizeGrid();

            var test = new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return grid;
        }

        private autoSize;
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();

            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            columns.forEach(col => col.cssClass += " col-allowBackground");

            columns.unshift({
                field: 'Dashboard',
                name: '',

                format: ctx => '<a class="inline-action user-dashboard" title="Dashboard">' +
                    '<i class="fa fa-box"></i> Dashboard</a>',
                width: 130,
                minWidth: 130,
                maxWidth: 160,
                sortable: false,
                resizable: false
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            let self = this;

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row) as NewsletterRow;

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('view-details')) {
                    this.editItem(item.NewsletterId);
                }
                else if (target.hasClass('user-dashboard')) {
                    e.preventDefault();

                    var user = Q.Authorization.userDefinition;
                    var tester = Q.getLookup<PaperTrail.Administration.UserRow>("Administration.User").items.filter(x => x.Username === user.Username)[0].UserId;
                    var userId = Administration.UserRow.getLookup().items
                        .filter(x => x.Username === user.Username)[0].UserId;

                    var diagUserDashboard = new NewsletterControl.SubscriptionListViewDialog();

                    this.initDialog(diagUserDashboard);
                    diagUserDashboard.set_dialogTitle("User Dashboard");

                    diagUserDashboard.userId = userId;

                    diagUserDashboard.dialogOpen(true);
                }
            }
        }
    }
}